import { lobConstants } from "../_constants";

 function setCurrentLob(payload) {
    return { type: lobConstants.CURRENT_LOB_SET, payload };
  }

  export const lobActions = {
    setCurrentLob,
  };
